export const environment = {
  production: true,
  apiRoot: 'https://be-live-ubie.app.ubiecloud.com/jwtapi',
  server: 'https://be-live-ubie.app.ubiecloud.com',
  logRoot: 'http://localhost:1337/api',
  mqtt: {
    host: 'be-live.mqtt.ubiecloud.com', hostname: 'be-live.mqtt.ubiecloud.com',
    user: '', pass: '', keepalive: 120, port: 8081, ssl: true, path: '', retain: false
  },
  configurations: {
    pagesConfig: 'pagesConfig'
  },
  calendar: 'https://be-live-calendar.app.ubiecloud.com/api',
  admin: true,
  semsaWizardUrl: 'https://luqaswizard.qbuscontrol.com',
  updateUri: 'https://be-live-ubie.app.ubiecloud.com/appchangelog/update-changelogv2.json',
  publishers: [
    {
      "loggerName": "console",
      "loggerLocation": "",
      "isActive":  true
    },
    {
      "loggerName": "sqlite",
      "loggerLocation": "",
      "isActive": true
    }
  ]
};

